import React from 'react';

import { PageTitle, Projects } from '../../../components';



const ProjectPage = () => {
 
  return ( 
    <>  
      {/* Page Title */}
      <PageTitle title={'Projects'} page={'Projects'} />

      {/* Projects Section */}
      <section>
        <Projects />
      </section>
    </>
  );
  
}

export default ProjectPage;